/**
 * 사내 용어 — 회의·이슈에서 설명 없이 튀어나오는 것만 모은다.
 * 정본은 각 저장소 문서다. 여기 정의가 저장소 문서와 어긋나면 저장소 쪽이 맞다.
 */
export interface Term {
  term: string;
  meaning: string;
  /** 신입이 자주 헷갈리는 지점 — 있으면 붙인다. */
  gotcha?: string;
}

export interface TermGroup {
  key: string;
  title: string;
  terms: Term[];
}

export const GLOSSARY: TermGroup[] = [
  {
    key: 'business',
    title: '🏪 사업 · 서비스',
    terms: [
      { term: '남도마켓 / ND마켓', meaning: 'B2B 도소매 커머스 본체입니다. 코드에서는 대체로 market 접두어를 씁니다', gotcha: '"남도몰(ndmall)"은 수출용 다국어 스토어로, 별개 프론트입니다' },
      { term: '복지몰 / careonplus', meaning: '기업 복지포인트몰입니다. 멀티테넌트 구조이고 DB·도메인이 남도마켓과 분리돼 있습니다', gotcha: '남도마켓 코드를 그대로 옮기면 안 됩니다 — 테넌트 개념이 다릅니다' },
      { term: '엉클 / 사입삼촌 · UNCLE POS', meaning: '도매 소싱과 POS를 다루는 별개 사업입니다. 남도마켓과는 교차 연동만 있습니다' },
      { term: '펭디', meaning: 'AI 쇼핑도우미(프론트 + 챗봇)입니다 🐧' },
      { term: '도매 / 소매', meaning: '같은 웹에서 로그인 주체에 따라 갈리는 두 모드입니다. 가격·노출 규칙이 다릅니다', gotcha: '버그를 재현할 때는 어느 모드인지 먼저 확인해 주세요' },
    ],
  },
  {
    key: 'commerce',
    title: '🛒 커머스 · 광고',
    terms: [
      { term: '기획전', meaning: '묶어서 노출하는 상품 모음입니다. 매장 기획전 · AI 기획전 · 상품 기획전으로 종류가 갈립니다', gotcha: '자동 정지 같은 운영 규칙이 종류마다 다릅니다 — 한 규칙을 전부에 적용하지 않도록 주의해 주세요' },
      { term: 'AI 상품광고', meaning: '일예산 기반 상품 광고입니다. 하루 상한을 쓰고 미소진분은 이월하지 않습니다' },
      { term: '끌올', meaning: '상품을 목록 상단으로 다시 올리는 행위입니다. 정렬 기준 중 하나(끌올순)로도 쓰입니다' },
      { term: '색인 / ES', meaning: '검색·랭킹용 Elasticsearch 색인입니다. nd-market-api가 변경을 알리고 nd-es-bridge가 색인합니다', gotcha: 'DB만 고치면 검색 결과는 안 바뀝니다. 색인 경로까지 확인해 주세요' },
      { term: '정산', meaning: '판매자 대금 정산입니다. 주문 테이블을 건드린다고 정산이 따라 움직이는 것은 아닙니다' },
    ],
  },
  {
    key: 'engineering',
    title: '🛠️ 개발 · 운영',
    terms: [
      { term: 'outbox', meaning: '변경을 테이블에 먼저 남기고 워커가 나중에 읽어 발행하는 방식입니다. 광고·색인 연동에서 씁니다' },
      { term: '하네스 (harness)', meaning: 'AI 코딩 에이전트로 기획→설계→구현→리뷰를 굴리는 사내 작업 파이프라인입니다', gotcha: '이 콘솔의 첫 화면(프로젝트 보드)이 하네스 문서를 색인해 보여주는 화면입니다' },
      { term: 'GitOps / ArgoCD', meaning: '배포 정본이 nd-k8s-manifests 저장소에 있고, ArgoCD가 클러스터를 그 상태로 맞춥니다', gotcha: '클러스터에 직접 kubectl apply 하면 다음 동기화에서 되돌아갑니다' },
      { term: 'IAP', meaning: 'Google Identity-Aware Proxy로, 내부 도구 앞단의 인증입니다. 이 콘솔도 IAP 뒤에 있습니다' },
      { term: 'dev / prod', meaning: 'GCP 프로젝트가 ndmarket-dev · ndmarket-prod로 갈립니다. 주소도 dev- 접두어로 구분됩니다' },
    ],
  },
];
